import Select, { StylesConfig } from "react-select";
import { SelectOption } from "../types";
import { reactSelectSMStyle, styles } from "Utils/Common";
import useLang from "Shared/hooks/useLanguage";

interface StepReagentInstrumentSelectProps {
  reagentOptions: SelectOption[];
  instrumentOptions: SelectOption[];
  selectedReagents: SelectOption[];
  selectedInstrument: string;
  onReagentChange: (value: SelectOption[]) => void;
  onInstrumentChange: (value: string) => void;
  isDisabled?: boolean;
}

export function StepReagentInstrumentSelect({
  reagentOptions,
  instrumentOptions,
  selectedReagents,
  selectedInstrument,
  onReagentChange,
  onInstrumentChange,
  isDisabled = false,
}: StepReagentInstrumentSelectProps) {
  const { t } = useLang();
  const selectedReagentOptions = selectedReagents.map(
    (selected) =>
      reagentOptions.find((r) => String(r.value) === String(selected.value)) ||
      selected
  );

  const selectStyles: StylesConfig<SelectOption> = {
    ...reactSelectSMStyle,
    control: (provided) => ({
      ...provided,
      minWidth: "100%",
      border: "1px solid #e5e5e5",
      borderRadius: "6px",
      "&:hover": {
        border: "1px solid #e5e5e5",
      },
    }),
  };

  return (
    <div className="mt-3 d-flex gap-3">
      <div style={{ flex: 1 }}>
        <label
          className="form-label mb-1 fw-500"
          style={{ fontSize: "13px", color: "#333" }}
        >
          {t("Please select reagents")}
        </label>
        <Select
          theme={(theme) => styles(theme)}
          options={reagentOptions}
          value={selectedReagentOptions}
          styles={selectStyles}
          menuPortalTarget={document.body}
          placeholder={`--- ${t("Select")} ---`}
          isSearchable={true}
          isMulti
          isDisabled={isDisabled}
          closeMenuOnSelect={false}
          onChange={(opt, _actionMeta) => {
            const selected = Array.isArray(opt) ? (opt as SelectOption[]) : [];
            onReagentChange(selected);
          }}
        />
      </div>
      <div style={{ flex: 1 }}>
        <label
          className="form-label mb-1 fw-500"
          style={{ fontSize: "13px", color: "#333" }}
        >
          {t("Please select an instrument")}
        </label>
        <Select
          theme={(theme) => styles(theme)}
          options={instrumentOptions}
          value={
            instrumentOptions.find(
              (i) => String(i.value) === selectedInstrument
            ) || null
          }
          styles={selectStyles}
          menuPortalTarget={document.body}
          placeholder={`--- ${t("Select")} ---`}
          isSearchable={true}
          isDisabled={isDisabled}
          onChange={(opt) => {
            const selected = opt as SelectOption | null;
            onInstrumentChange(selected ? String(selected.value) : "");
          }}
        />
      </div>
    </div>
  );
}
